// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Avatar,
//   Chip,
//   CircularProgress,
//   Alert,
//   Pagination,
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   useTheme,
//   useMediaQuery,
//   Skeleton,
//   Button,
//   TablePagination,
//   FormControl,
//   Select,
//   MenuItem,
//   InputLabel,
// } from "@mui/material";
// import { Pets, Refresh } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// const PetCareProducts = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalCount, setTotalCount] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const baseUrl = "https://api.medstown.com"; // Replace with your actual base URL

//   // MedsToWin brand colors
//   const medsToWinColors = {
//     primary: "#2E7D32",
//     secondary: "#4CAF50",
//     accent: "#81C784",
//     light: "#C8E6C9",
//     skeleton: "rgba(46, 125, 50, 0.15)",
//     gradient: "linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%)",
//   };

//   const fetchProducts = async (page = 1, limit = 10) => {
//     setLoading(true);
//     setError(null);

//     try {
//       const response = await fetch(
//         `${baseUrl}/api/medshubs/otc-products?page=${page}&limit=${limit}&search=pet care`
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       if (data.success) {
//         setProducts(data.data.list);
//         setTotalPages(data.data.totalPages);
//         setTotalCount(data.data.totalCount);
//         setCurrentPage(data.data.currentPage);
//       } else {
//         throw new Error(data.message || "Failed to fetch products");
//       }
//     } catch (err) {
//       setError(err.message);
//       setProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProducts(currentPage, rowsPerPage);
//   }, [currentPage, rowsPerPage]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowsPerPageChange = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     setRowsPerPage(newRowsPerPage);
//     setCurrentPage(1); // Reset to first page when changing rows per page
//   };

//   // For TablePagination component
//   const handleTablePageChange = (event, newPage) => {
//     setCurrentPage(newPage + 1); // TablePagination uses 0-based indexing
//   };

//   const formatPrice = (price) => {
//     return `₹${parseInt(price).toLocaleString()}`;
//   };

//   // Header Component
//   const PetCareHeader = ({ showCount = true }) => (
//     <Box
//       sx={{
//         background: medsToWinColors.gradient,
//         color: "white",
//         py: { xs: 2.5, md: 4 },
//         mb: { xs: 2, md: 3 },
//         borderRadius: 2,
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           top: -20,
//           right: -20,
//           opacity: 0.1,
//           fontSize: { xs: "4rem", md: "8rem" },
//         }}
//       >
//         <Pets />
//       </Box>
//       <Container>
//         <Grid container alignItems="center" spacing={{ xs: 1.5, md: 2 }}>
//           <Grid item>
//             <Box
//               sx={{
//                 backgroundColor: "rgba(255,255,255,0.2)",
//                 borderRadius: "50%",
//                 p: { xs: 1.5, md: 2 },
//                 display: "flex",
//               }}
//             >
//               <Pets sx={{ fontSize: { xs: "1.5rem", md: "2rem" } }} />
//             </Box>
//           </Grid>
//           <Grid item xs>
//             <Typography
//               variant={isMobile ? "h5" : "h4"}
//               fontWeight="bold"
//               gutterBottom
//             >
//               Pet Care Products
//             </Typography>
//             <Typography
//               variant={isMobile ? "body2" : "subtitle1"}
//               sx={{ opacity: 0.9 }}
//             >
//               Premium healthcare solutions for your beloved pets
//             </Typography>
//           </Grid>
//           {showCount && (
//             <Grid item>
//               <Box textAlign="right">
//                 <Typography variant={isMobile ? "h6" : "h6"} fontWeight="bold">
//                   {totalCount}
//                 </Typography>
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Total Products
//                 </Typography>
//               </Box>
//             </Grid>
//           )}
//         </Grid>
//       </Container>
//     </Box>
//   );

//   // Mobile Pagination Controls
//   const MobilePaginationControls = () => (
//     <Box sx={{ mt: 2, mb: 2 }}>
//       {/* Rows per page selector for mobile */}
//       <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
//         <FormControl size="small" sx={{ minWidth: 120 }}>
//           <InputLabel
//             sx={{
//               color: medsToWinColors.primary,
//               "&.Mui-focused": { color: medsToWinColors.primary },
//             }}
//           >
//             Show
//           </InputLabel>
//           <Select
//             value={rowsPerPage}
//             onChange={handleRowsPerPageChange}
//             label="Show"
//             sx={{
//               "& .MuiOutlinedInput-notchedOutline": {
//                 borderColor: medsToWinColors.light,
//               },
//               "&:hover .MuiOutlinedInput-notchedOutline": {
//                 borderColor: medsToWinColors.primary,
//               },
//               "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                 borderColor: medsToWinColors.primary,
//               },
//             }}
//           >
//             <MenuItem value={10}>10</MenuItem>
//             <MenuItem value={25}>25</MenuItem>
//             <MenuItem value={50}>50</MenuItem>
//             <MenuItem value={100}>100</MenuItem>
//             <MenuItem value={150}>150</MenuItem>
//           </Select>
//         </FormControl>
//         <Typography variant="body2" sx={{ ml: 1, color: "text.secondary" }}>
//           per page
//         </Typography>
//       </Box>

//       {/* Standard pagination */}
//       <Box display="flex" justifyContent="center">
//         <Pagination
//           count={totalPages}
//           page={currentPage}
//           onChange={handlePageChange}
//           color="primary"
//           size="small"
//           sx={{
//             "& .MuiPaginationItem-root": {
//               "&.Mui-selected": {
//                 backgroundColor: medsToWinColors.primary,
//                 "&:hover": {
//                   backgroundColor: medsToWinColors.secondary,
//                 },
//               },
//               "&:hover": {
//                 backgroundColor: medsToWinColors.light,
//               },
//             },
//           }}
//         />
//       </Box>

//       {/* Page info */}
//       <Box display="flex" justifyContent="center" mt={1}>
//         <Typography variant="caption" color="text.secondary">
//           Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
//           {Math.min(currentPage * rowsPerPage, totalCount)} of {totalCount}{" "}
//           products
//         </Typography>
//       </Box>
//     </Box>
//   );

//   // Desktop Pagination Controls (TablePagination)
//   const DesktopPaginationControls = () => (
//     <TablePagination
//       component="div"
//       count={totalCount}
//       page={currentPage - 1} // TablePagination uses 0-based indexing
//       onPageChange={handleTablePageChange}
//       rowsPerPage={rowsPerPage}
//       onRowsPerPageChange={handleRowsPerPageChange}
//       rowsPerPageOptions={[10, 25, 50, 100, 150]}
//       labelRowsPerPage="Products per page:"
//       labelDisplayedRows={({ from, to, count }) =>
//         `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
//       }
//       sx={{
//         borderTop: `1px solid ${medsToWinColors.light}`,
//         "& .MuiTablePagination-toolbar": {
//           paddingLeft: 2,
//           paddingRight: 2,
//         },
//         "& .MuiTablePagination-select": {
//           "&:focus": {
//             backgroundColor: "transparent",
//           },
//         },
//         "& .MuiTablePagination-actions button": {
//           "&:hover": {
//             backgroundColor: medsToWinColors.light,
//           },
//         },
//         "& .MuiIconButton-root": {
//           "&.Mui-disabled": {
//             opacity: 0.5,
//           },
//         },
//       }}
//     />
//   );

//   // Mobile Skeleton Loading
//   const MobileSkeletonLoader = () => (
//     <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2 } }}>
//       <PetCareHeader showCount={false} />

//       {/* Mobile Cards Skeleton */}
//       <Box sx={{ px: { xs: 0.5, sm: 0 } }}>
//         {Array.from(new Array(rowsPerPage > 10 ? 10 : rowsPerPage)).map(
//           (_, index) => (
//             <Card
//               key={index}
//               sx={{
//                 mb: 1.5,
//                 borderLeft: `4px solid ${medsToWinColors.primary}`,
//                 boxShadow: 1,
//               }}
//             >
//               <CardContent sx={{ py: 1.5, px: 2 }}>
//                 <Grid container spacing={1.5} alignItems="center">
//                   <Grid item xs={3}>
//                     <Skeleton
//                       variant="rounded"
//                       width={50}
//                       height={50}
//                       sx={{
//                         bgcolor: medsToWinColors.skeleton,
//                         borderRadius: 1,
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={9}>
//                     <Skeleton
//                       variant="text"
//                       width="95%"
//                       height={18}
//                       sx={{ bgcolor: medsToWinColors.skeleton, mb: 0.5 }}
//                     />
//                     <Skeleton
//                       variant="text"
//                       width="75%"
//                       height={18}
//                       sx={{ bgcolor: medsToWinColors.skeleton, mb: 1 }}
//                     />
//                     <Skeleton
//                       variant="text"
//                       width="60%"
//                       height={14}
//                       sx={{ bgcolor: medsToWinColors.skeleton, mb: 1 }}
//                     />
//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="center"
//                       mb={0.5}
//                     >
//                       <Skeleton
//                         variant="text"
//                         width={60}
//                         height={20}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                       <Skeleton
//                         variant="rounded"
//                         width={40}
//                         height={24}
//                         sx={{
//                           bgcolor: medsToWinColors.skeleton,
//                           borderRadius: 3,
//                         }}
//                       />
//                     </Box>
//                     <Skeleton
//                       variant="text"
//                       width={80}
//                       height={12}
//                       sx={{ bgcolor: medsToWinColors.skeleton }}
//                     />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           )
//         )}
//       </Box>

//       <MobilePaginationControls />
//     </Container>
//   );

//   // Desktop Skeleton Loading
//   const DesktopSkeletonLoader = () => (
//     <Container maxWidth="lg">
//       <PetCareHeader showCount={false} />

//       <Paper sx={{ boxShadow: 3, borderRadius: 2 }}>
//         <TableContainer sx={{ overflow: "auto" }}>
//           <Table sx={{ minWidth: 800 }}>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: medsToWinColors.light }}>
//                 <TableCell
//                   sx={{
//                     fontWeight: "bold",
//                     color: medsToWinColors.primary,
//                     minWidth: 80,
//                   }}
//                 >
//                   Product Id
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     fontWeight: "bold",
//                     color: medsToWinColors.primary,
//                     minWidth: 300,
//                   }}
//                 >
//                   Name
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     fontWeight: "bold",
//                     color: medsToWinColors.primary,
//                     minWidth: 180,
//                   }}
//                 >
//                   Pack Size
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     fontWeight: "bold",
//                     color: medsToWinColors.primary,
//                     minWidth: 100,
//                   }}
//                 >
//                   Price
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     fontWeight: "bold",
//                     color: medsToWinColors.primary,
//                     minWidth: 80,
//                   }}
//                 >
//                   Type
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     fontWeight: "bold",
//                     color: medsToWinColors.primary,
//                     minWidth: 120,
//                   }}
//                 >
//                   SKU
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {Array.from(new Array(rowsPerPage > 10 ? 10 : rowsPerPage)).map(
//                 (_, index) => (
//                   <TableRow key={index}>
//                     <TableCell>
//                       <Skeleton
//                         variant="rounded"
//                         width={50}
//                         height={50}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Skeleton
//                         variant="text"
//                         width="80%"
//                         height={20}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Skeleton
//                         variant="text"
//                         width="70%"
//                         height={16}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Skeleton
//                         variant="text"
//                         width="60%"
//                         height={24}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Skeleton
//                         variant="rounded"
//                         width={50}
//                         height={24}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Skeleton
//                         variant="text"
//                         width="80%"
//                         height={14}
//                         sx={{ bgcolor: medsToWinColors.skeleton }}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 )
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <DesktopPaginationControls />
//       </Paper>
//     </Container>
//   );

//   // Mobile Product Card
//   const MobileProductCard = ({ product }) => (
//     <Card
//       sx={{
//         mb: 1.5,
//         borderLeft: `4px solid ${medsToWinColors.primary}`,
//         boxShadow: 1,
//         "&:hover": {
//           boxShadow: 2,
//           transform: "translateY(-1px)",
//           transition: "all 0.2s ease-in-out",
//         },
//       }}
//     >
//       <CardContent sx={{ py: 1.5, px: 2 }}>
//         <Grid container spacing={1.5} alignItems="center">
//           <Grid item xs={3}>
//             {/* <Avatar
//               src={product.image}
//               alt={product.name}
//               sx={{ width: 50, height: 50 }}
//               variant="rounded"
//             /> */}
//             <Typography
//               variant="body1"
//               fontSize="0.85rem"
//               fontWeight="600"
//               gutterBottom
//               sx={{
//                 lineHeight: 1.3,
//                 display: "-webkit-box",
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//               }}
//             >
//               {product.id}
//             </Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <Typography
//               variant="body1"
//               fontSize="0.85rem"
//               fontWeight="600"
//               gutterBottom
//               sx={{
//                 lineHeight: 1.3,
//                 display: "-webkit-box",
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//               }}
//               onClick={() =>
//                 navigate(`/admin/pet-care-individual-page/${product.cid}`)
//               }
//               style={{ cursor: "pointer" }}
//             >
//               {product.name}
//             </Typography>
//             <Typography
//               variant="body2"
//               fontSize="0.75rem"
//               color="textSecondary"
//               gutterBottom
//               sx={{ mb: 1 }}
//             >
//               {product.pack_size_label}
//             </Typography>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//               mb={0.5}
//             >
//               <Typography
//                 variant="h6"
//                 fontSize="1rem"
//                 color={medsToWinColors.primary}
//                 fontWeight="bold"
//               >
//                 {formatPrice(product.price)}
//               </Typography>
//               <Chip
//                 label="OTC"
//                 size="small"
//                 sx={{
//                   backgroundColor: medsToWinColors.light,
//                   color: medsToWinColors.primary,
//                   fontWeight: "bold",
//                   fontSize: "0.7rem",
//                   height: 20,
//                 }}
//               />
//             </Box>
//             <Typography
//               variant="caption"
//               fontSize="0.7rem"
//               color="textSecondary"
//               display="block"
//             >
//               SKU: {product.sku_id}
//             </Typography>
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );

//   // Loading State
//   if (loading) {
//     return isMobile ? <MobileSkeletonLoader /> : <DesktopSkeletonLoader />;
//   }

//   // Error State
//   if (error) {
//     return (
//       <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2 } }}>
//         <PetCareHeader showCount={false} />
//         <Alert
//           severity="error"
//           sx={{
//             mb: 3,
//             borderRadius: 2,
//             "& .MuiAlert-icon": {
//               color: medsToWinColors.primary,
//             },
//           }}
//           action={
//             <Button
//               size="small"
//               onClick={() => fetchProducts(currentPage, rowsPerPage)}
//               startIcon={<Refresh />}
//               sx={{
//                 color: medsToWinColors.primary,
//                 "&:hover": {
//                   backgroundColor: medsToWinColors.light,
//                 },
//               }}
//             >
//               Retry
//             </Button>
//           }
//         >
//           <Typography variant="subtitle1" fontWeight="600" gutterBottom>
//             Error Loading Pet Care Products
//           </Typography>
//           <Typography variant="body2">{error}</Typography>
//         </Alert>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2 } }}>
//       <PetCareHeader />

//       {/* Mobile View */}
//       {isMobile ? (
//         <>
//           <Box sx={{ px: { xs: 0.5, sm: 0 } }}>
//             {products.map((product) => (
//               <MobileProductCard key={product._id} product={product} />
//             ))}
//           </Box>
//           <MobilePaginationControls />
//         </>
//       ) : (
//         /* Desktop Table View with Advanced Pagination */
//         <Paper sx={{ boxShadow: 3, borderRadius: 2 }}>
//           <TableContainer sx={{ overflow: "auto", maxWidth: "100%" }}>
//             <Table sx={{ minWidth: 800 }}>
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: medsToWinColors.light }}>
//                   <TableCell
//                     sx={{
//                       fontWeight: "bold",
//                       color: medsToWinColors.primary,
//                       minWidth: 80,
//                     }}
//                   >
//                     Product Id
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       fontWeight: "bold",
//                       color: medsToWinColors.primary,
//                       minWidth: 300,
//                     }}
//                   >
//                     Name
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       fontWeight: "bold",
//                       color: medsToWinColors.primary,
//                       minWidth: 180,
//                     }}
//                   >
//                     Pack Size
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       fontWeight: "bold",
//                       color: medsToWinColors.primary,
//                       minWidth: 100,
//                     }}
//                   >
//                     Price
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       fontWeight: "bold",
//                       color: medsToWinColors.primary,
//                       minWidth: 80,
//                     }}
//                   >
//                     Type
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       fontWeight: "bold",
//                       color: medsToWinColors.primary,
//                       minWidth: 120,
//                     }}
//                   >
//                     SKU
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {products.map((product) => (
//                   <TableRow
//                     key={product._id}
//                     sx={{
//                       "&:hover": {
//                         backgroundColor: "rgba(46, 125, 50, 0.04)",
//                       },
//                     }}
//                   >
//                     <TableCell>
//                       <Typography variant="body1" fontWeight="500">
//                         {product.id}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="body1"
//                         fontWeight="500"
//                         onClick={() =>
//                           navigate(
//                             `/admin/pet-care-individual-page/${product.cid}`
//                           )
//                         }
//                         style={{ cursor: "pointer" }}
//                         sx={{
//                           lineHeight: 1.3,
//                         }}
//                       >
//                         {product.name}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography variant="body2" color="textSecondary">
//                         {product.pack_size_label}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h6"
//                         color={medsToWinColors.primary}
//                         fontWeight="bold"
//                       >
//                         {formatPrice(product.price)}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Chip
//                         label={product.type.toUpperCase()}
//                         size="small"
//                         sx={{
//                           backgroundColor: medsToWinColors.light,
//                           color: medsToWinColors.primary,
//                           fontWeight: "bold",
//                         }}
//                       />
//                     </TableCell>
//                     <TableCell>
//                       <Typography variant="body2" color="textSecondary">
//                         {product.sku_id}
//                       </Typography>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <DesktopPaginationControls />
//         </Paper>
//       )}
//     </Container>
//   );
// };

// export default PetCareProducts;




import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Chip,
  Alert,
  Container,
  Grid,
  useTheme,
  useMediaQuery,
  Skeleton,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { Pets, Refresh, ImageNotSupported } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PetCareCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const baseUrl = "https://api.medstown.com";

  // MedsToWin brand colors
  const medsToWinColors = {
    primary: "#2E7D32",
    secondary: "#4CAF50",
    accent: "#81C784",
    light: "#C8E6C9",
    skeleton: "rgba(46, 125, 50, 0.15)",
    gradient: "linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%)",
  };

  const fetchCategories = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${baseUrl}/api/medshubs/categories?upcat=612`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setCategories(data.data.list);
      } else {
        throw new Error(data.message || "Failed to fetch categories");
      }
    } catch (err) {
      setError(err.message);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Header Component
  const PetCareHeader = () => (
    <Box
      sx={{
        background: medsToWinColors.gradient,
        color: "white",
        py: { xs: 2.5, md: 4 },
        mb: { xs: 2, md: 3 },
        borderRadius: 2,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -20,
          right: -20,
          opacity: 0.1,
          fontSize: { xs: "4rem", md: "8rem" },
        }}
      >
        <Pets />
      </Box>
      <Container>
        <Grid container alignItems="center" spacing={{ xs: 1.5, md: 2 }}>
          <Grid item>
            <Box
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                borderRadius: "50%",
                p: { xs: 1.5, md: 2 },
                display: "flex",
              }}
            >
              <Pets sx={{ fontSize: { xs: "1.5rem", md: "2rem" } }} />
            </Box>
          </Grid>
          <Grid item xs>
            <Typography
              variant={isMobile ? "h5" : "h4"}
              fontWeight="bold"
              gutterBottom
            >
              Pet Care Categories
            </Typography>
            <Typography
              variant={isMobile ? "body2" : "subtitle1"}
              sx={{ opacity: 0.9 }}
            >
              Manage all pet care categories and subcategories
            </Typography>
          </Grid>
          <Grid item>
            <Box textAlign="right">
              <Typography variant={isMobile ? "h6" : "h6"} fontWeight="bold">
                {categories.length}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                Categories
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );

  // Mobile Card Component
  const MobileCategoryCard = ({ category }) => (
    <Card
      sx={{
        mb: 1.5,
        borderLeft: `4px solid ${medsToWinColors.primary}`,
        boxShadow: 1,
        cursor: "pointer",
        "&:hover": {
          boxShadow: 2,
          transform: "translateY(-1px)",
          transition: "all 0.2s ease-in-out",
        },
      }}
      onClick={() => navigate(`/admin/pet-care-medicine-list/${category.cid}`)}
    >
      <CardContent sx={{ py: 1.5, px: 2 }}>
        <Grid container spacing={1.5} alignItems="center">
          <Grid item xs={3}>
            {category.image_url ? (
              <Avatar
                src={category.image_url}
                alt={category.name}
                sx={{ width: 50, height: 50 }}
                variant="rounded"
              />
            ) : (
              <Avatar
                sx={{
                  width: 50,
                  height: 50,
                  backgroundColor: medsToWinColors.light,
                  color: medsToWinColors.primary,
                }}
                variant="rounded"
              >
                <ImageNotSupported />
              </Avatar>
            )}
          </Grid>
          <Grid item xs={9}>
            <Typography
              variant="body1"
              fontSize="0.9rem"
              fontWeight="600"
              color={medsToWinColors.primary}
              gutterBottom
              sx={{
                lineHeight: 1.3,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {category.name}
            </Typography>
            <Typography
              variant="body2"
              fontSize="0.75rem"
              color="textSecondary"
              gutterBottom
              sx={{ mb: 1 }}
            >
              Parent: {category.upcat_name}
            </Typography>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="caption"
                fontSize="0.7rem"
                color="textSecondary"
              >
                ID: {category.cid}
              </Typography>
              <Chip
                label={category.status ? "Active" : "Inactive"}
                size="small"
                sx={{
                  backgroundColor: category.status
                    ? medsToWinColors.light
                    : "#ffebee",
                  color: category.status
                    ? medsToWinColors.primary
                    : "#d32f2f",
                  fontWeight: "bold",
                  fontSize: "0.7rem",
                  height: 20,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  // Desktop Table Skeleton Loading
  const TableSkeletonLoader = () => (
    <Paper sx={{ boxShadow: 3, borderRadius: 2 }}>
      <TableContainer sx={{ overflow: "auto" }}>
        <Table sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: medsToWinColors.light }}>
              <TableCell sx={{ fontWeight: "bold", color: medsToWinColors.primary, minWidth: 80 }}>
                Image
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: medsToWinColors.primary, minWidth: 200 }}>
                Category Name
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: medsToWinColors.primary, minWidth: 100 }}>
                Category ID
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: medsToWinColors.primary, minWidth: 150 }}>
                Parent Category
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: medsToWinColors.primary, minWidth: 100 }}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from(new Array(8)).map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton
                    variant="rounded"
                    width={50}
                    height={50}
                    sx={{ bgcolor: medsToWinColors.skeleton }}
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={20}
                    sx={{ bgcolor: medsToWinColors.skeleton }}
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={16}
                    sx={{ bgcolor: medsToWinColors.skeleton }}
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    variant="text"
                    width="70%"
                    height={16}
                    sx={{ bgcolor: medsToWinColors.skeleton }}
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    variant="rounded"
                    width={60}
                    height={24}
                    sx={{ bgcolor: medsToWinColors.skeleton }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );

  // Mobile Skeleton Loading
  const MobileSkeletonLoader = () => (
    <Box sx={{ px: { xs: 0.5, sm: 0 } }}>
      {Array.from(new Array(8)).map((_, index) => (
        <Card
          key={index}
          sx={{
            mb: 1.5,
            borderLeft: `4px solid ${medsToWinColors.primary}`,
            boxShadow: 1,
          }}
        >
          <CardContent sx={{ py: 1.5, px: 2 }}>
            <Grid container spacing={1.5} alignItems="center">
              <Grid item xs={3}>
                <Skeleton
                  variant="rounded"
                  width={50}
                  height={50}
                  sx={{
                    bgcolor: medsToWinColors.skeleton,
                    borderRadius: 1,
                  }}
                />
              </Grid>
              <Grid item xs={9}>
                <Skeleton
                  variant="text"
                  width="90%"
                  height={18}
                  sx={{ bgcolor: medsToWinColors.skeleton, mb: 0.5 }}
                />
                <Skeleton
                  variant="text"
                  width="70%"
                  height={14}
                  sx={{ bgcolor: medsToWinColors.skeleton, mb: 1 }}
                />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Skeleton
                    variant="text"
                    width={60}
                    height={12}
                    sx={{ bgcolor: medsToWinColors.skeleton }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={50}
                    height={20}
                    sx={{
                      bgcolor: medsToWinColors.skeleton,
                      borderRadius: 3,
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}
    </Box>
  );

  // Error State
  const ErrorState = () => (
    <Alert
      severity="error"
      sx={{
        mb: 3,
        borderRadius: 2,
        "& .MuiAlert-icon": {
          color: medsToWinColors.primary,
        },
      }}
      action={
        <Button
          size="small"
          onClick={fetchCategories}
          startIcon={<Refresh />}
          sx={{
            color: medsToWinColors.primary,
            "&:hover": {
              backgroundColor: medsToWinColors.light,
            },
          }}
        >
          Retry
        </Button>
      }
    >
      <Typography variant="subtitle1" fontWeight="600" gutterBottom>
        Error Loading Pet Care Categories
      </Typography>
      <Typography variant="body2">{error}</Typography>
    </Alert>
  );

  // Main Render
  return (
    <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2 } }}>
      <PetCareHeader />

      {/* Loading State */}
      {loading && (
        <>
          {isMobile ? <MobileSkeletonLoader /> : <TableSkeletonLoader />}
        </>
      )}

      {/* Error State */}
      {error && !loading && <ErrorState />}

      {/* Success State */}
      {!loading && !error && (
        <>
          {/* Mobile View */}
          {isMobile ? (
            <Box sx={{ px: { xs: 0.5, sm: 0 } }}>
              {categories.map((category) => (
                <MobileCategoryCard key={category._id} category={category} />
              ))}
            </Box>
          ) : (
            /* Desktop Table View */
            <Paper sx={{ boxShadow: 3, borderRadius: 2 }}>
              <TableContainer sx={{ overflow: "auto", maxWidth: "100%" }}>
                <Table sx={{ minWidth: 800 }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: medsToWinColors.light }}>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: medsToWinColors.primary,
                          minWidth: 80,
                        }}
                      >
                        Image
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: medsToWinColors.primary,
                          minWidth: 200,
                        }}
                      >
                        Category Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: medsToWinColors.primary,
                          minWidth: 100,
                        }}
                      >
                        Category ID
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: medsToWinColors.primary,
                          minWidth: 150,
                        }}
                      >
                        Parent Category
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: medsToWinColors.primary,
                          minWidth: 100,
                        }}
                      >
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {categories.map((category) => (
                      <TableRow
                        key={category._id}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(46, 125, 50, 0.04)",
                            cursor: "pointer",
                          },
                        }}
                        onClick={() =>
                          navigate(`/admin/pet-care-medicine-list/${category.cid}`)
                        }
                      >
                        <TableCell>
                          {category.image_url ? (
                            <Avatar
                              src={category.image_url}
                              alt={category.name}
                              sx={{ width: 50, height: 50 }}
                              variant="rounded"
                            />
                          ) : (
                            <Avatar
                              sx={{
                                width: 50,
                                height: 50,
                                backgroundColor: medsToWinColors.light,
                                color: medsToWinColors.primary,
                              }}
                              variant="rounded"
                            >
                              <ImageNotSupported />
                            </Avatar>
                          )}
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body1"
                            fontWeight="500"
                            color={medsToWinColors.primary}
                            sx={{
                              "&:hover": {
                                textDecoration: "underline",
                              },
                            }}
                          >
                            {category.name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            fontFamily="monospace"
                          >
                            {category.cid}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="textSecondary">
                            {category.upcat_name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={category.status ? "Active" : "Inactive"}
                            size="small"
                            sx={{
                              backgroundColor: category.status
                                ? medsToWinColors.light
                                : "#ffebee",
                              color: category.status
                                ? medsToWinColors.primary
                                : "#d32f2f",
                              fontWeight: "bold",
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}

          {/* No Data State */}
          {categories.length === 0 && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minHeight="300px"
              sx={{ color: "text.secondary" }}
            >
              <Pets sx={{ fontSize: "4rem", opacity: 0.3, mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                No Categories Found
              </Typography>
              <Typography variant="body2" textAlign="center">
                There are no pet care categories available at the moment.
              </Typography>
            </Box>
          )}
        </>
      )}
    </Container>
  );
};

export default PetCareCategories;
